export const DEPLOY_AI_TEAM_CTA = 'Deploy Your AI Team';
